export default __webpack_public_path__ + "static/media/finosec_sidebar_logo.f0f4e9cb.png";